/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Play = (props: any) => (
<svg {...props}   viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M17.5297 14.666C19.4901 13.47 19.4901 10.5299 17.5297 9.33398L9.49438 4.43174C7.50628 3.21884 5 4.70554 5 7.09775V16.9022C5 19.2945 7.50628 20.7812 9.49438 19.5682L17.5297 14.666Z" fill="inherit"/>
</svg>
);

export default Play;